import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DreamComponent } from './dream.component';
import { DreamRoutingModule } from './dream-routing.module';
import { MyCustomMaterialModule } from 'san-common';
import { DreamsViewComponent } from './dreams-view/dreams-view.component';
import { DreamViewComponent } from './dream-view/dream-view.component';
import { ItemsSharedModule } from 'modul-shared';



@NgModule({
  imports: [
    CommonModule,
    DreamRoutingModule,
    MyCustomMaterialModule,
    
      ItemsSharedModule       
  ],
  declarations: [DreamComponent,
    DreamsViewComponent,
    DreamViewComponent

    ],
  exports: [DreamComponent]
})
export class DreamModule { }
